import { render, staticRenderFns } from "./auth-message.vue?vue&type=template&id=593db72a&scoped=true&"
import script from "./auth-message.vue?vue&type=script&lang=js&"
export * from "./auth-message.vue?vue&type=script&lang=js&"
import style0 from "./auth-message.vue?vue&type=style&index=0&id=593db72a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593db72a",
  null
  
)

export default component.exports